// extracted by mini-css-extract-plugin
module.exports = {"item":"Pathway_item__NXWgY","trigger":"Pathway_trigger__iDUwb","content":"Pathway_content__I1rRX"};